import utils from '../utils';
import { ERROR_TYPES, getErrorMessage } from './error-types';
export default {
    name: 'mwc-markets-component-ui-mixin',
    props: {
        skin: {
            type: String,
            default: ''
        },
        namespaced: {
            type: Boolean,
            default: false
        },
        showLoading: {
            type: Boolean,
            default: false
        },
        errorCode: {
            type: String,
            default: ''
        },
        settings: {
            type: Object,
            default() {
                return {};
            }
        },
        labels: {
            type: Object,
            default() {
                return {};
            }
        },
        formatter: {
            type: Object
        }
    },
    data() {
        return {
            error: {},
            watchedSettings: {}
        };
    },
    watch: {
        skin: {
            handler(value) {
                this.$set(this.watchedSettings, 'skin', value);
            },
            immediate: true
        },
        namespaced: {
            handler(value) {
                this.$set(this.watchedSettings, 'namespaced', value);
            },
            immediate: true
        },
        settings: {
            handler(value) {
                this._setWatchedSettings(value);
            },
            deep: true
        }
    },
    computed: {
        errorMessage() {
            let msg = '';
            const errorCode = this.errorCode || this.error.code;
            if (errorCode) {
                msg =
                    this.initedLabels[errorCode] ||
                    this._getErrorMessage(errorCode);
            }
            return msg || this.error.message || '';
        },
        showWebLayout() {
            return (
                this.watchedSettings.showSetting &&
                !this.watchedSettings.showHeader
            );
        }
    },
    created() {
        this._setWatchedSettings(this.settings);
    },
    beforeCreate() {
        this.ERROR_TYPES = ERROR_TYPES;
    },
    mounted() {
        utils.resizeObserver.observe(this.$el, this._resizeCallback);
    },
    beforeDestroy() {
        utils.resizeObserver.unobserve(this.$el, this._resizeCallback);
    },
    destroyed() {
        this.$emit('destroyed');
    },
    methods: {
        _resizeCallback({ entry }) {
            if (this._resizeObserverCallback) {
                this._resizeObserverCallback({
                    entry
                });
            } else {
                if (this.hideSettingsPopover) {
                    this.hideSettingsPopover();
                }
            }
        },
        mdsNS(context) {
            return utils.mdsNS(
                context,
                (this.watchedSettings || {}).namespaced
            );
        },
        _getErrorMessage(errorCode) {
            return getErrorMessage(errorCode);
        },
        getDisplaySymbol(security = {}, withMICCode = true) {
            const symbol =
                security.clientSymbol ||
                security.mstarSymbol ||
                security.rtSymbol ||
                '–';
            let exch = '';
            if (withMICCode && security.MICCode) {
                exch = `${security.MICCode}:`;
            }
            return `${exch}${symbol}`;
        },
        changeSettings(settings) {
            this.$emit('settings-changed', settings);
        },
        getDefaultLabels(labels, languageId = 'en') {
            return (
                labels[languageId] ||
                labels[languageId.replace(/(.+)-.+/, '$1')] ||
                labels.en
            );
        },
        mergeLabels(propsLabels, defaultLabels) {
            return utils.extend({}, defaultLabels, propsLabels);
        },
        _setWatchedSettings(settings) {
            const convertSettingKeys = [
                'settingsItem',
                'currencySet',
                'viewTypeOptions',
                'groupOptions',
                'crossRatesDefaultCurrencySet',
                'boardDefaultCurrencySet',
                'crossRatesSelectedCurrencySet',
                'boardSelectedCurrencySet',
                'tableSelectedCurrencySet',
                'tableCurrencySet',
                'cryptocurrencySet',
                'selectedCryptocurrencySet',
                'boardBreakpoints',
                'boardBaseCurrencySet',
                'crossRatesBaseCurrencySet'
            ];
            Object.keys(settings).forEach(key => {
                let value = settings[key];
                if (utils.findIndex(convertSettingKeys, key) > -1) {
                    value = value.split(',');
                }
                this.$set(this.watchedSettings, key, value);
            });
        }
    }
};
